export class UserLoginModel {
    USER_NAME:string='';
    USER_PASSWORD:string='';
    USER_CONFIRM_PASSWORD:string='';
    FORGOT_VENDOR_CODE:string="";
}
